function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.335,
    height: 22.334,
    viewBox: "0 0 22.335 22.334",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3728"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5708",
    d: "M286.871 209.4h-8.841a.7.7 0 1 1 0-1.4h8.841a.7.7 0 0 1 0 1.4zm0 0",
    transform: "translate(-265.234 -198.935)",
    style: {
      fill: "#e10007"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5709",
    d: "M400.7 136.347a.7.7 0 0 1-.493-1.192l3-3-3-3a.7.7 0 0 1 .987-.987l3.49 3.49a.7.7 0 0 1 0 .987l-3.49 3.49a.693.693 0 0 1-.494.212zm0 0",
    transform: "translate(-382.555 -122.388)",
    style: {
      fill: "#e10007"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5710",
    d: "M7.445 22.342a1.918 1.918 0 0 1-.577-.087l-5.6-1.866A1.878 1.878 0 0 1 0 18.62V1.869A1.863 1.863 0 0 1 1.861.008a1.919 1.919 0 0 1 .577.087l5.6 1.866A1.878 1.878 0 0 1 9.306 3.73v16.75a1.863 1.863 0 0 1-1.861 1.862zM1.861 1.4a.467.467 0 0 0-.465.465V18.62a.484.484 0 0 0 .323.448l5.574 1.857a.506.506 0 0 0 .152.02.467.467 0 0 0 .465-.465V3.73a.484.484 0 0 0-.323-.448L2.013 1.424a.505.505 0 0 0-.152-.024zm0 0",
    transform: "translate(0 -.008)",
    style: {
      fill: "#e10007"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5711",
    d: "M39.7 7.453a.7.7 0 0 1-.7-.7V2.567A1.165 1.165 0 0 0 37.835 1.4H27.366a.7.7 0 0 1 0-1.4h10.469a2.561 2.561 0 0 1 2.559 2.559v4.196a.7.7 0 0 1-.694.698zm0 0",
    transform: "translate(-25.505 -.008)",
    style: {
      fill: "#e10007"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5712",
    d: "M185.752 284.785h-3.722a.7.7 0 1 1 0-1.4h3.722a1.165 1.165 0 0 0 1.163-1.163v-4.188a.7.7 0 1 1 1.4 0v4.188a2.561 2.561 0 0 1-2.563 2.563zm0 0",
    transform: "translate(-173.422 -265.242)",
    style: {
      fill: "#e10007"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.d476f273f2ab044499c44f96d8049a03.svg";
export { ForwardRef as ReactComponent };